import { FormPhoneField } from "@pharmupp/p3-front-commons"
import { fields } from "../../GeneralInfos.fields"
import { isPhoneRequired } from "../../GeneralInfos.rg"
import { useGetUserTypeField } from "../useGetUserTypeField"

export const ConditionalPhoneField = () => {
  const type = useGetUserTypeField()

  const required = isPhoneRequired(type)

  return (
    <FormPhoneField
      name={fields.phone}
      label="Téléphone portable"
      required={required}
    />
  )
}
